import * as CONST from "./actionTypes";

export const getCurrency = (payload) => ({
  type: CONST.GET_CURRENCY,
  payload: payload,
});

export const getCurrencySuccess = (data) => ({
  type: CONST.GET_CURRENCY_SUCCESS,
  payload: data,
});

export const getCurrencyFail = (error) => ({
  type: CONST.GET_CURRENCY_FAIL,
  payload: error,
});




